export const detectClientIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete client" || cleaned === "remove client") {
        return { intent: "delete_client" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) client/);
    if (deleteMatch) {
        return { intent: "delete_client", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create client") || cleaned.includes("add client")) {
        return { intent: "create_client" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create client named (.+)/);
    if (createMatch) {
        return { intent: "create_client", name: createMatch[1].trim() };
    }

    return null;
};
